const textReplace = content => {
  return (
    content
      // image src replacement
      .replace(/src="\/sites/g, `src="${process.env.REACT_APP_DRUPAL_URL}/sites`)

      .replace(
        new RegExp('href="(https?|ftp)://((?!' + document.domain + ').)*?."', 'g'),
        (match, i) => {
          return match + ' target="_blank"'
        },
      )
  )
}

export default textReplace
